<template>
  <div class="c-profiles-item">
    <div
      class="c-profiles-item__avatar-wrapper"
      :class="{ active: subscriber.activeProfileId === profile.id }"
    >
      <v-avatar
        :profile="profile"
        :edit="editMode"
        @action="action"
      ></v-avatar>
    </div>

    <div class="c-profiles-item__profile-name o-typography__subtitle1">
      {{ profile.name }}
    </div>
  </div>
</template>
<script>
  import { VAvatar } from '@/index/shared/components';
  import ProfileAction from './profile-action';

  export default {
    components: {
      VAvatar,
    },
    props: {
      profile: undefined,
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
        profilesService: this.$services.resolve('profiles'),
      };
    },
    methods: {
      action() {
        this.editMode ? this.edit() : this.switchProfile();
      },
      switchProfile() {
        this.$emit('action', ProfileAction.SWITCH_PROFILE, this.profile);
      },
      edit() {
        this.$emit('action', ProfileAction.SHOW_EDIT, this.profile);
      },
    },
  };
</script>
